import { useEffect, useState } from "react";
import {
  Row,
  Col,
  Breadcrumb,
  Typography,
  Dropdown,
  Modal,
  Space,
  Button,
} from "antd";
import { NavLink } from "react-router-dom";
import React from "react";
import { VscAccount } from "react-icons/vsc";
import {
  AiOutlinePoweroff,
  AiOutlineSetting,
  AiOutlineUser,
} from "react-icons/ai";
import { GrMoney } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import { useDispatch, useSelector } from "react-redux";
import { useCountry } from "../../provider/courtryProvider";
import { removePushNotificationToken } from "../../hooks/usePushNotification";
import routerPath from "../../routerAuth/routerPath";
import { useLocation } from "react-router-dom";

const getBreadcrumbs = (location) => {
  const segments = location.pathname.split("/").filter(Boolean);
  const crumbs = [{ path: "/", label: "Home" }];
  let path = "";
  segments.forEach((segment) => {
    path += `/${segment}`;
    const matchedRoute = routerPath.find((r) => r.path === path);
    const label =
      matchedRoute?.title ||
      segment.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    crumbs.push({ path, label });
  });
  return crumbs;
};

const Breadcrumbs = ({ location }) => (
  <div className="breadcrumbs">
    <Breadcrumb>
      {getBreadcrumbs(location).map((crumb) => (
        <Breadcrumb.Item key={crumb.path}>
          {location.pathname === crumb.path ? (
            <Typography.Text
              style={{
                textTransform: "capitalize",
                fontWeight: 500,
              }}
            >
              {crumb.label}
            </Typography.Text>
          ) : (
            <NavLink to={crumb.path}>{crumb.label}</NavLink>
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  </div>
);

function Header() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const dispatch = useDispatch();
  const userType = useSelector((state) => state.shopDetails.userType);
  const country = useCountry();
  const shopDetails = useSelector((state) => state.shopDetails);
  const location = useLocation();

  const items = [
    {
      key: "1",
      label: "Profile",
      icon: <AiOutlineUser size={16} />,
    },
    {
      key: "3",
      label: "Logout",
      icon: <AiOutlinePoweroff size={16} />,
    },
  ];

  const handleMenuClick = (event) => {
    const key = event.key;

    if (key === "1") {
      navigate("/dashboard/settings");
    } else if (key === "2") {
      navigate("/dashboard/plan-and-pricing");
    } else if (key === "3") {
      setLogoutModal(true);
    }
  };

  const handleLogout = async () => {
    setLoader(true);
    window.localStorage.clear();
    await removePushNotificationToken(
      shopDetails?.shopId,
      shopDetails?.userEndpointARN,
    );
    Auth.signOut()
      .then((res) => {
        dispatch({
          type: "IS_LOGGEDIN",
          payload: false,
        });
        navigate("/login");
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (userType === "Shop") {
      const planPricing = {
        key: "2",
        label: "Plan and Pricing",
        style: {
          display: country.CountryCode === "IN" ? "inherit" : "none",
        },
        icon: <GrMoney size={16} />,
      };
      items.splice(1, 0, planPricing);
    }
  }, [userType, items]);

  const route = routerPath.find((path) => path.path === location.pathname);
  return (
    <div
      style={{
        marginTop: 8,
      }}
    >
      <Row gutter={[24, 0]}>
        <Col span={24} md={10}>
          <Breadcrumbs location={location} />
          <div className="ant-page-header-heading">
            <span
              className="ant-page-header-heading-title"
              style={{ textTransform: "capitalize" }}
            >
              {route?.title}
            </span>
          </div>
        </Col>

        <Dropdown
          menu={{
            items,
            onClick: handleMenuClick,
          }}
          onOpenChange={() => {}}
        >
          <VscAccount
            size={40}
            style={{
              position: "absolute",
              right: 20,
              top: 20,
              cursor: "pointer",
            }}
          />
        </Dropdown>
      </Row>
      <Modal
        open={logoutModal}
        onCancel={() => {
          setLogoutModal(false);
        }}
        width={450}
        closable={false}
        centered
        footer={false}
      >
        <Typography.Title level={4}>
          Are you sure you want to Log out?
        </Typography.Title>
        <Space
          style={{
            textAlign: "right",
            justifyContent: "right",
            display: "flex",
            alignItems: "center",
            marginTop: 20,
          }}
          direction="horizontal"
        >
          <Button
            onClick={() => {
              setLogoutModal(false);
            }}
            type="primary"
            ghost
          >
            No
          </Button>
          <Button onClick={handleLogout} loading={loader} type="primary">
            Yes
          </Button>
        </Space>
      </Modal>
    </div>
  );
}

export default Header;
